import {
  RawDraftContentBlock,
  StylePrefix,
  getInlineStylesValue,
  getValueFromStyle,
} from '@msd-npm-gmc-dev/gmc-dc-assembler-draftjs2lexical';
import { BrandColorRef } from 'modules/BrandDefinition';
import { SerializedCustomListItemNode } from 'modules/Lexical/nodes/CustomListItemNode';
import { SerializedCustomListNode, CustomListNode } from 'modules/Lexical/nodes/CustomListNode';
import { DefaultTextStyles } from 'const/Styles';

function escapeRegExp(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
const reBulletColorName = new RegExp(`^${escapeRegExp(StylePrefix.BULLET_COLOR)}(?!#)`);

function getBulletColor(styles: string[]): BrandColorRef | undefined {
  let name: string | undefined = getInlineStylesValue(styles, StylePrefix.BULLET_COLOR_NAME);
  if (!name) {
    // There is a bug in DraftJS, so color name could be stored with wrong prefix
    const styleForName = styles.find(value => reBulletColorName.test(value));
    name = styleForName && getValueFromStyle(styleForName, StylePrefix.BULLET_COLOR);
  }

  let HEX: string | undefined = undefined;
  const styleForHEX = styles.find(value => value.startsWith(`${StylePrefix.BULLET_COLOR}#`));
  if (styleForHEX) {
    HEX = getValueFromStyle(styleForHEX, StylePrefix.BULLET_COLOR);
  } else {
    const legacyHex = styles.find(value => value.startsWith(`${StylePrefix.BULLET_COLOR_LEGACY}#`));
    HEX = legacyHex && getValueFromStyle(legacyHex, StylePrefix.BULLET_COLOR_LEGACY);
  }

  if (!name && !HEX) {
    return undefined;
  }

  const tint = getInlineStylesValue(styles, StylePrefix.BULLET_COLOR_TINT);

  return {
    name,
    HEX: HEX ?? (DefaultTextStyles.bulletColor as string),
    tint: tint ? parseInt(tint, 10) : undefined,
  };
}

export function createListNode(
  contentBlock: RawDraftContentBlock,
  children: SerializedCustomListItemNode[],
  depth: number,
): SerializedCustomListNode {

  let color: BrandColorRef | undefined;
  if (depth === 0) {
    const { inlineStyleRanges } = contentBlock;
    color = getBulletColor(inlineStyleRanges.map(range => range.style));
  }

  return {
    direction: 'ltr',
    type: CustomListNode.getType(),
    indent: 1,
    version: 1,
    start: 1,
    format: '',
    listType: 'bullet',
    tag: 'ul',
    children,
    color,
  };
}
